package ru.villawonka.app.presentation.screens.searchFilter.compose.layout

import androidx.compose.runtime.Composable
import ru.villawonka.app.platform.platform.model.PlatformType
import ru.villawonka.app.presentation.screens.searchFilter.compose.SearchFilterCallbacks
import ru.villawonka.app.presentation.screens.searchFilter.viewmodel.SearchFilterUIState
import ru.villawonka.app.presentation.sharedviews.DefaultErrorStateLayout
import ru.villawonka.app.presentation.sharedviews.DefaultLoadingStateLayout

@Composable
fun SearchFilterRootLayout(
    platformType: PlatformType,
    state: SearchFilterUIState,
    callbacks: SearchFilterCallbacks
) {
    when (state) {
        is SearchFilterUIState.Loading -> DefaultLoadingStateLayout()
        is SearchFilterUIState.Error -> DefaultErrorStateLayout(
            failure = state.failure,
            onRetryClick = callbacks.onRetryButtonClick
        )
        is SearchFilterUIState.Data.Accommodation -> SearchFilterAccommodationStateLayout(
            platformType = platformType,
            state = state,
            callbacks = callbacks
        )
        is SearchFilterUIState.Data.Transport -> SearchFilterTransportStateLayout(
            platformType = platformType,
            state = state,
            callbacks = callbacks
        )
    }
}
